import { action } from 'typesafe-actions';
import { ResponseError } from '../../../services/api';
import { AdditionalScreenTypes, AdditionalScreen } from './types';

export const additionalScreensRequest = () => action(AdditionalScreenTypes.LOAD_REQUEST);
export const additionalScreensSuccess = (screens: AdditionalScreen[]) =>
  action(AdditionalScreenTypes.LOAD_SUCCESS, { screens });
export const additionalScreensFailure = (error: ResponseError) =>
  action(AdditionalScreenTypes.LOAD_FAILURE, { error });
